import React, { useRef } from 'react';
import uuidv4 from 'uuid/v4';
export const Checkbox = ({ id: idOuter, checked, onChange, label, disabled }) => {
    const ref = useRef(null);
    const id = React.useMemo(() => idOuter || uuidv4(), [idOuter]);
    const handleChange = ({ target: { checked } }) => {
        onChange(checked);
    };
    return (<div className="checkbox">
      <input id={id} ref={ref} disabled={disabled} onChange={handleChange} checked={checked} type="checkbox"/>
      <label htmlFor={id}>
        <div className="icon check-field-icon"></div>
        <div className="icon icon-ok"></div>
        <span>{label}</span>
      </label>
    </div>);
};
